import React from "react"; // Usunięto useState, bo nie będzie już lokalnego stanu settings
import { useGame } from "@/contexts/GameContext"; // Do nawigacji i resetu gry
import { useSettings } from "@/contexts/SettingsContext"; // <<< NOWY IMPORT
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import {
  ArrowLeft,
  Palette,
  Volume2,
  VolumeX,
  Save, // Ikona dla autosave
  Accessibility, // Ikona dla redukcji ruchu
  RotateCcw,
  Settings as SettingsIconUI, // Zmieniono nazwę, aby uniknąć konfliktu z settings ze stanu
  User2,
  Sun,
  Moon,
  Monitor, // Ikony dla motywów
} from "lucide-react";
import { toast } from "sonner";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
// import { ThemeToggle } from "@/components/settings/ThemeToggle"; // <<< USUWAMY, zastąpimy własnym
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

const appVersion = __APP_VERSION__;

export default function SettingsScreen() {
  const { dispatch: gameDispatch } = useGame(); // Używamy tylko gameDispatch
  const { settings, dispatchSettings } = useSettings(); // <<< POBIERAMY USTAWIENIA I DISPATCH Z NOWEGO KONTEKSTU

  const goBack = () => {
    gameDispatch({ type: "SET_SCREEN", payload: "start" });
  };

  const resetGame = () => {
    gameDispatch({ type: "RESET_GAME" });
    toast.success("Gra została zresetowana!");
  };

  // Nie potrzebujemy już lokalnego `updateSetting`

  const themeOptions = [
    { value: "light", label: "Jasny", icon: Sun },
    { value: "dark", label: "Ciemny", icon: Moon },
    { value: "system", label: "Systemowy", icon: Monitor },
  ];

  return (
    <>
      {/* Header */}
      <header className="flex items-center justify-between w-full mb-8">
        <Button
          variant="ghost"
          size="icon"
          onClick={goBack}
          className="rounded-full"
        >
          <ArrowLeft className="size-5" />
        </Button>
        <h1 className="text-xl font-semibold">Ustawienia</h1>
        <div className="w-9" /> {/* Spacer */}
      </header>

      <main className="flex-1 space-y-6 pb-10">
        {/* Motyw */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              {/* Dodano flex i gap */}
              <Palette className="w-5 h-5 text-primary" /> Motyw aplikacji
            </CardTitle>
            <CardDescription>
              Wybierz preferowany wygląd interfejsu.
            </CardDescription>
          </CardHeader>
          <CardContent className="grid grid-cols-3 gap-2">
            {themeOptions.map((option) => (
              <Button
                key={option.value}
                variant={
                  settings.theme === option.value ? "default" : "outline"
                }
                onClick={() =>
                  dispatchSettings({ type: "SET_THEME", payload: option.value })
                }
                className="flex flex-col h-auto py-3 gap-1"
              >
                <option.icon
                  className={`w-5 h-5 mb-1 ${
                    settings.theme === option.value
                      ? ""
                      : "text-muted-foreground"
                  }`}
                />
                <span className="text-xs">{option.label}</span>
              </Button>
            ))}
          </CardContent>
        </Card>

        {/* Ogólne */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <SettingsIconUI className="w-5 h-5 text-primary" /> Ogólne
            </CardTitle>
            <CardDescription>Dostosuj zachowanie aplikacji.</CardDescription>
          </CardHeader>
          <CardContent className="grid gap-4">
            {/* Dźwięki */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                {settings.soundEnabled ? (
                  <Volume2 className="w-5 h-5 text-sky-500" />
                ) : (
                  <VolumeX className="w-5 h-5 text-muted-foreground" />
                )}
                <span>Dźwięki w aplikacji</span>
              </div>
              <Switch
                checked={settings.soundEnabled}
                onCheckedChange={() =>
                  dispatchSettings({ type: "TOGGLE_SOUND" })
                }
                id="sound-switch"
              />
            </div>
            {/* Wibracje */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-lg">
                  📳 {/* Emoji dla wibracji */}
                </span>
                <span>Wibracje (mobilne)</span>
              </div>
              <Switch
                checked={settings.vibrationEnabled}
                onCheckedChange={() =>
                  dispatchSettings({ type: "TOGGLE_VIBRATION" })
                }
                id="vibration-switch"
              />
            </div>
            {/* Redukcja Ruchu (zamiast Animacje) */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Accessibility
                  className={`w-5 h-5 ${
                    settings.reduceMotion
                      ? "text-orange-500"
                      : "text-muted-foreground"
                  }`}
                />
                <span>Redukcja ruchu</span>
              </div>
              <Switch
                checked={settings.reduceMotion}
                onCheckedChange={() =>
                  dispatchSettings({ type: "TOGGLE_REDUCE_MOTION" })
                }
                id="reduce-motion-switch"
              />
            </div>
            {/* Auto-zapis Gry */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Save
                  className={`w-5 h-5 ${
                    settings.autoSaveGame
                      ? "text-green-500"
                      : "text-muted-foreground"
                  }`}
                />
                <span>Automatyczny zapis gry</span>
              </div>
              <Switch
                checked={settings.autoSaveGame}
                onCheckedChange={() =>
                  dispatchSettings({ type: "TOGGLE_AUTOSAVE_GAME" })
                }
                id="autosave-switch"
              />
            </div>
          </CardContent>
        </Card>

        {/* Zarządzanie danymi */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <User2 className="w-5 h-5 text-primary" /> Zarządzanie danymi
            </CardTitle>
            <CardDescription>Zarządzaj zapisanymi danymi gry.</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <AlertDialog>
              <AlertDialogTrigger asChild>
                <Button
                  variant="destructive"
                  className="w-full flex items-center gap-2" // Usunięto nadpisanie koloru
                >
                  <RotateCcw className="w-4 h-4" />
                  Resetuj grę
                </Button>
              </AlertDialogTrigger>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>
                    Czy na pewno chcesz zresetować grę?
                  </AlertDialogTitle>
                  <AlertDialogDescription>
                    Ta akcja usunie wszystkich zapisanych graczy oraz aktualny
                    postęp gry. Ustawienia aplikacji pozostaną niezmienione.
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel>Anuluj</AlertDialogCancel>
                  <AlertDialogAction
                    onClick={resetGame}
                    // className="bg-destructive text-destructive-foreground hover:bg-destructive/90" // Można usunąć, aby użyć domyślnych stylów
                  >
                    Tak, resetuj
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
            <p className="text-xs text-muted-foreground text-center">
              Resetuje graczy, postęp gry i ustawienia sesji.
            </p>
          </CardContent>
        </Card>

        {/* Informacje o aplikacji (bez zmian) */}
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="justify-center">DareMe</CardTitle>
            <CardDescription>
              <p className="text-sm text-muted-foreground mb-1">
                Wersja {appVersion}
              </p>
              <p className="text-xs text-muted-foreground">
                Made with ❤️ for party games
              </p>
            </CardDescription>
          </CardHeader>
        </Card>
      </main>
    </>
  );
}
